module.exports = __webpack_public_path__ + "static/ieee_logo_circle-0997b1dd1a3efe2a66eab4ed34a4df11.png";